import { Dialog, Slide } from "@mui/material";
import React, { forwardRef, useState } from "react";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />; // slide downwards
});

const SectionModal = ({ onClose, open, handleSubmit, sectionInfo, handleEditSection, previewInput = null }) => {
  const [inputs, setInputs] = useState(
    previewInput ?? { name: sectionInfo?.sectionName ?? "", description: sectionInfo?.sectionDescription ?? "" }
  );

  const handleClose = () => {
    onClose();
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();

    if (sectionInfo?.sectionId) {
      handleEditSection({
        event,
        sectionId: sectionInfo?.sectionId,
        sectionName: inputs?.name,
        sectionDescription: inputs?.description,
      });
    } else {
      handleSubmit({ inputs });
    }
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "rounded-2xl shadow-xl mt-10", // push it down a bit from very top
      }}
      TransitionComponent={Transition} // <-- correct prop for transition
      keepMounted
      sx={{
        "& .MuiDialog-container": {
          alignItems: "flex-start", // align to top instead of middle
        },
      }}
    >
      <form className="flex flex-col gap-6 p-4" onSubmit={handleFormSubmit}>
        {/* Header */}
        <p className="font-semibold text-lg text-gray-800">
          {sectionInfo?.sectionId ? `Update ${sectionInfo?.sectionName}` : "Add New Section"}

          <span className="font-bold text-indigo-700 text-xl">
            {/* {previewInput?.isOpen && previewInput?.data?.inputInfo?.label} */}
          </span>
        </p>

        {/* Name field */}
        <div className="flex flex-col gap-1">
          <label htmlFor="name" className="text-sm font-medium text-gray-600">
            Name
          </label>
          <input
            autoFocus
            required
            name="name"
            type="text"
            placeholder="Enter your name"
            className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
            value={inputs?.name}
            onChange={(e) => setInputs((prev) => ({ ...prev, name: e.target.value }))}
          />
        </div>

        {/* Description field */}
        {/* <div className="flex flex-col gap-1">
          <label htmlFor="description" className="text-sm font-medium text-gray-600">
            Description
          </label>
          <textarea
            name="description"
            placeholder="Description"
            rows={3}
            className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none resize-none"
            value={inputs?.description}
            onChange={(e) => setInputs((prev) => ({ ...prev, description: e.target.value }))}
          />
        </div> */}

        {/* Action buttons */}
        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300 transition"
            type="reset"
            onClick={handleClose}
          >
            Cancel
          </button>
          {/* <button
            className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300 transition"
            type="reset"
            onClick={() => setInputs({ name: "", description: "" })}
          >
            Clear
          </button> */}
          <button
            className="px-4 py-2 rounded-lg  bg-[#5489FF] hover:bg-[#004EFF] text-white  transition"
            type="submit"
          >
            Save
          </button>
        </div>
      </form>
    </Dialog>
  );
};

export default SectionModal;
